import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        selectionList({commit, dispatch, rootState}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/administrator/services/selection-list',
                    { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        fetch({commit, dispatch, rootState}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/services/list',
                { params: filter }
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        add({commit, dispatch, rootState}, data) {
            return axios.post(
                '/api/manager/services/add',
                prepareData(data, rootState),
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch, rootState}, editedItem) {
            return axios.post(
                '/api/manager/services/edit/' + editedItem.id,
                prepareData(editedItem, rootState),
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch}, itemId) {
            return axios.delete(
                '/api/manager/services/dell/' + itemId
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
    }
}

function prepareData (data, rootState) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('hotel_id', String(rootState.auth.currentHotel.id))
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    if (data.prices) {
        const prices = data.prices.map((item) => {
            item.value = Number(item.value)
            return item
        })
        fd.append('prices', JSON.stringify(prices))
    }
    if (data.description) {
        fd.append('description', data.description)
    }
    if (data.duration) {
        fd.append('duration', data.duration)
    }
    if (data.price_value) {
        fd.append('price_value', data.price_value)
    }
    fd.append('published', Number(data.published))
    fd.append('is_complex', Number(data.is_complex))
    if (typeof data.is_available_others !== 'undefined') {
        fd.append('is_available_others', Number(data.is_available_others))
    }
    fd.append('type', data.type)

    return fd
}
